import { api } from '@/http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import type { MfaRemoveMethodRequest } from '@eye-able/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

/** Turns one of the user's methods off; costs password and a current code. */
export function useRemoveMfaMethod() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: MfaRemoveMethodRequest) =>
      fetchWrapper.post<{ message: string }>(api.mfaRemove, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [api.mfa] }),
  });
}
